import { createFileRoute } from "@tanstack/react-router";
import type { QcStaffSearch } from "@/features/performance/qc-overview/staff/QcStaffPage";
import type { QcTab, SheetFilter } from "@/features/performance/qc-overview/qc-audit-lib";

// Trang siêu chi tiết một QC (QĐ 0484) — mở từ Bảng QC, từ chuông "bài bạn
// chấm đã được soát", hoặc link gửi tay. Mọi trạng thái (tháng, thẻ, lọc, bài
// đang mở) nằm trên địa chỉ để gửi link là người nhận thấy đúng chỗ.
const FILTERS: readonly string[] = ["all", "unaudited", "failed", "regraded", "today"];
const TABS: readonly string[] = ["sheets", "pending", "site"];

function str(v: unknown): string | undefined {
  return typeof v === "string" && v !== "" ? v : undefined;
}

export const Route = createFileRoute("/_app/qc-overview/qc/$staffId")({
  validateSearch: (s: Record<string, unknown>): QcStaffSearch => {
    const month = str(s.month);
    const filter = str(s.filter);
    const tab = str(s.tab);
    return {
      month: month && /^\d{4}-\d{2}$/.test(month) ? month : undefined,
      filter: filter && FILTERS.includes(filter) ? (filter as SheetFilter) : undefined,
      tab: tab && TABS.includes(tab) ? (tab as QcTab) : undefined,
      sheet: str(s.sheet),
      kind: str(s.kind),
    };
  },
});
